// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"3838d566727ba199872b","117":"cba230dfbc2fa19b1e1a","118":"f00f5495acfd42cfdc01","173":"beed25258329f87d50f2"}[chunkId] + ".chunk.js";
};